module.exports = __webpack_public_path__ + "static/media/download2.08d58bb0.svg";